import BlackChevron from "@/assets/svgs/BlackChevron";
export const ValueTrackSell = ({
  titleOne,
  textOne,
  titleTwo,
  textTwo,
  titleThree,
  textThree,
  removeDescription,
}) => {
  return (
    <div className="VTS">
      <div className="VTS-item">
        <div className="VTS-title-wrapper">
          <BlackChevron className="black-chevron" />

          <h2>{titleOne}</h2>
        </div>

        {!removeDescription && <p>{textOne}</p>}
      </div>
      <div className="VTS-item">
        <div className="VTS-title-wrapper">
          <BlackChevron className="black-chevron" />
          <h2>{titleTwo}</h2>
        </div>

        {!removeDescription && <p>{textTwo}</p>}
      </div>
      <div className="VTS-item">
        <div className="VTS-title-wrapper">
          <BlackChevron className="black-chevron" />
          <h2>{titleThree}</h2>
        </div>

        {!removeDescription && <p>{textThree}</p>}
      </div>
    </div>
  );
};
